import React, { Component, Fragment } from "react";
import { DateTime } from "luxon";
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { withTranslation } from "react-i18next";
import CaseAPI from "../../api/CaseAPI";
import WorkflowAPI from "../../api/WorkflowAPI";
import _ from "lodash";
import debounce from 'lodash/debounce';
import ReactHtmlParser from 'react-html-parser';
import Filter from "../cases/Filter";
import { filterCaseDataByFilterMenu } from "../../utils/CaseDataFilter";
import feather from 'feather-icons';
import Loading from "./Loading";


const $ = window.$;


function FormatData(props) {
  const rowData = props.cell._cell.row.data;
  const cellValue = props.cell._cell.value;
  let classList = props.cell._cell.row.element.classList;

  if (rowData.highlightStr) {
    if (classList) {
      classList.add(rowData.highlightStyle);
    }
    return <div>
      <span>{cellValue}</span> &nbsp;
      {ReactHtmlParser(rowData.highlightStr)}
    </div>;
  } else {
    return <span>{cellValue}</span>;
  }
}
class CaseTable extends Component {
  ref = null;
  cState = null;
  selectedColumns = []

  constructor(props) {
    super(props);
    this.state = {
      ...this.props.state,
      t: this.props.t,
      searchText: "",
      pageData: [],
      isSearch: false,
      allCaseBtn: true,
      myCaseBtn: false,
      columnsBtn: false,
      wfColumns: [],
      columnCount: 0,
      isEnableSearchButton: false,
      tempSelectedColumns: [],
      tempWfColumns: [],
      actionId: "",
      actionLink: "",
      shortcutIcon: "",
      isPinned: "",
      shortcutName: "",
      pageInfo: {},
      currentPage: 1,
      lastPage: -1,
      paginationSize: window.ENV.REACT_APP_FILTER_PAGE_SIZE,
      dataPerAPICall: window.ENV.REACT_APP_FILTER_DATA_PER_API_CALL,
      loading: false,
      presentData: [],
      loadedData: {},
      filters: [],
      sort: {
        field: "",
        sortingOrder: "asc",
        locale: "nb"
      },
      currentSort: { field: "", sortingOrder: "asc", locale: "nb" }
    };
    const { t } = this.state;

    this.options = {
      tooltips: true,
      placeholder: "<Fragment><section className='content-header'><h4 style='text-align:center'><i>" + t('caseManagement.noCasesMessage') + "</i></h4></section></Fragment>",
      movableColumns: true,
      pagination: "remote",
      paginationSize: this.state.paginationSize,
      ajaxURL: 'dummy_string_url',
      download: true,
      ajaxRequestFunc: (url, config, params) => {
        let _this = this;
        const locale = _this.props.i18n?.language || "nb";
        $('.tabulator-alert').hide();

        return new Promise(function (resolve, reject) {
          try {
            if (params.sort && params.sort.length > 0) {
              const sortField = params.sort[0].field;
              _this.setState(prevState => {
                const newSort = prevState.currentSort.field === sortField
                    ? { field: sortField, sortingOrder: prevState.currentSort.sortingOrder === "asc" ? "desc" : "asc", locale: locale }
                    : { field: sortField, sortingOrder: "asc", locale: locale };
                return { currentSort: newSort };
              }, () => {
                _this.loadFirstPageData(resolve, _this.state.currentSort);
              });
            } else {
              _this.loadFirstPageData(resolve);
            }
          } catch (error) {
            console.error("Caught with promise:", error.message);
            reject(error);
          }
        });
      },
      langs: {
        all: {
          pagination: {
            first: t("common.table.pagination.first"),
            first_title: t("common.table.pagination.first_title"),
            last: t("common.table.pagination.last"),
            last_title: t("common.table.pagination.last_title"),
            prev: t("common.table.pagination.prev"),
            prev_title: t("common.table.pagination.prev_title"),
            next: t("common.table.pagination.next"),
            next_title: t("common.table.pagination.next_title")
          }
        }
      },
      sortMode: "remote",
    };

    this.debouncedSearch = debounce(this.getSearchCases, 500);
  }

  modifyColumnsForDateSorting = (columns) => {
    return columns.map((column) => {
      if (column.sorter === 'datetime' || column.sorter === 'date') {
        return {
          ...column,
          sorterParams: {
            format: 'DD.MM.YYYY [kl.] HH:mm',
            alignEmptyValues: 'bottom',
          },
          formatter: (cell) => {
            const value = cell.getValue();
            if (!value) return '';

            const formatRegex = /^\d{2}\.\d{2}\.\d{4} kl\.\s\d{2}:\d{2}$/;
            if (formatRegex.test(value)) {
              return value;
            }

            let date = DateTime.fromISO(value);
            if (!date.isValid) {
              date = DateTime.fromFormat(value, 'DD.MM.YYYY HH:mm');
            }

            return date.isValid ? date.toFormat('DD.MM.YYYY [kl.] HH:mm') : 'Invalid Date';
          },
          formatterParams: {
            inputFormat: 'DD.MM.YYYY [kl.] HH:mm',
            outputFormat: 'DD.MM.YYYY [kl.] HH:mm',
            invalidPlaceholder: 'Invalid Date',
          },
        };
      } else {
        // Add alignEmptyValues to ALL non-date columns too
        return {
          ...column,
          sorter: column.sorter || 'string',
          sorterParams: {
            ...column.sorterParams,
            alignEmptyValues: 'bottom',
          }
        };
      }
    });
  };


  rowClick = (e, row) => {
    this.ref.table.deselectRow();
    this.ref.table.selectRow(row);
    let caseData = row.getData();
    caseData.columns = this.state.columns;
    this.props.rowClick(caseData);
  };

  shouldComponentUpdate(nextProps, nextState) {
    this.cState = nextProps.state.caseState;
    if (this.props.state.caseState !== nextState.caseState) {
      this.setState({ allCaseBtn: true, myCaseBtn: false, columnsBtn: false });
      $("input[name=column]").prop('checked', false);
      this.getWorkflowColumns();
    }
    return true;
  }

  tempColumns = [
    { field: 'workflowName', width: '', title: 'Workflow Name', align: 'left' },
    { field: 'caseState', width: '', title: 'Case State', align: 'left' },
    { field: 'sessionRef', width: '', title: 'Session Ref', align: 'left' },
    { field: 'workflowRef', width: '', title: 'Workflow Ref', align: 'left' },
    { field: 'workflowVersion', width: '', title: 'W version', align: 'left' },
    { field: 'worker', width: '', title: 'Created by', align: 'left' }
  ]

  removeNullValue = (data, columns) => {
    columns.forEach((column) => {
      let field = column.field;

      // Handle all types of empty values consistently
      const normalizeEmptyValue = (value) => {
        if (value === null || value === undefined) return null;
        if (typeof value === 'string') {
          const trimmed = value.trim();
          if (trimmed === "" || trimmed === "-" || trimmed === "null") {
            return null;
          }
        }
        return value;
      };

      if (field.indexOf('.') === -1) {
        data[field] = normalizeEmptyValue(data[field]);
      } else if (field.includes('metadata.')) {
        field = field.replace('metadata.', '');
        field = field.replace('.value', '');
        if (data.metadata && data.metadata[field]) {
          let metadata = data.metadata[field];
          metadata.value = normalizeEmptyValue(metadata.value);
        }
      } else if (field.includes('auditInfo.')) {
        field = field.replace('auditInfo.', '');
        if (data.auditInfo && data.auditInfo[field]) {
          data.auditInfo[field] = normalizeEmptyValue(data.auditInfo[field]);
        }
      }
    });
  };


  componentWillUnmount() {
    // Cancel any pending debounced search to prevent unwanted API calls after unmount
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
  }

  decorateWithHighlight = (columns) => {
    columns.forEach((column) => {
      if (column.field === "uniqueId") {
        column.formatter = reactFormatter(
          <FormatData />
        )
      }
    });
  }

  onHandleFilterData = (workflowIndex, caseStateId) => {
    const filters = filterCaseDataByFilterMenu(workflowIndex, caseStateId);

    this.setState({
        filters: filters
    }, () => {
        // Load data after filters are set in state
        this.loadFirstPageData();
    });
  }

  componentDidMount() {
    let loggedInUser = sessionStorage.getItem("loggedInUser");
    if (loggedInUser) {
      loggedInUser = JSON.parse(loggedInUser);
      this.setState({
        user: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
        workflowList: loggedInUser.workflowList,
        isEnableSearchButton: loggedInUser.enableSearchButton,
        loggedInUser: loggedInUser
      })
    }
    this.getActiveFilters();
    feather.replace();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { caseState, workflowId } = this.props.state;
    if (prevProps.state.caseState !== caseState || prevProps.state.workflowId !== workflowId) {
      this.setState({
        tempSelectedColumns: [],
        tempWfColumns: [],allCaseBtn: true, myCaseBtn: false }, () => {
        this.getActiveFilters();
      });
    }
    feather.replace();
  }

  componentWillReceiveProps(nextProps) {
    let defaultColumns = nextProps.state.columns;
    if (!nextProps.state.columns || nextProps.state.columns.length === 0) {
      defaultColumns = this.tempColumns;
    }

    defaultColumns = this.modifyColumnsForDateSorting(defaultColumns);

    // Apply highlighting formatter to columns
    this.decorateWithHighlight(defaultColumns);

    this.setState(prevState => ({
      columns: prevState.tempSelectedColumns.length !== 0 ? prevState.tempSelectedColumns : defaultColumns,
      wfColumns: prevState.tempWfColumns.length !== 0 ? prevState.tempWfColumns : nextProps.state.wfColumns,
      columnCount: defaultColumns.length,
      pageData: nextProps.state.data,
      caseState: nextProps.state.caseState,
      workflowId: nextProps.state.workflowId,
      caseStateTitle: nextProps.state.caseStateTitle,
      caseStateId: nextProps.state.caseStateId,
      toggle: true,
    }));
    if (this.cState !== nextProps.state.caseState) {
      this.setState({
        searchText: ""
      });
    }
  }

  getActiveFilters = () => {
    const filters = filterCaseDataByFilterMenu(this.state.workflowIndex, this.props.state.caseStateId);

    if(filters) {
      this.setState({
        filters: filters
      });
    }
  }

  getWorkflowColumns = () => {
    WorkflowAPI.getWorkflowColumnsWithType(this.state.workflowIndex, this.props.state.caseStateId).then(data => {
      this.setState({ wfColumns: data });
    });
  }

  saveCaseUpdateAttributeData() {
    let uRole = "";
    let userGroups = [];
    let uGroups = "";

    this.state.loggedInUser.workflowList.forEach(workflow => {
      if (workflow.workflow.workflowId === this.state.workflowId) {
        uRole = workflow.role.name;
        userGroups = workflow.userGroups;
      }
    });

    if (userGroups) {
      uGroups = userGroups.map(item => item.groupTitle).join(', ');
    }

    const caseUpdateAttributeData = {
      caseEntryId: "ShortcutEntry",
      action: null,
      assn: this.state.loggedInUser.uniqueId,
      comment: null,
      workerEmail: null,
      entryTitle: this.props.state.shortcutName,
      aEmail: this.state.loggedInUser.email,
      workerName: null,
      aName: this.state.loggedInUser.firstName + ' ' + this.state.loggedInUser.lastName,
      aRole: this.props.t("roles." + uRole),
      aGroups: (uGroups ? uGroups : '')
    };

    let response = CaseAPI.saveCaseUpdateAttribute(caseUpdateAttributeData);

    response.then( res =>{
      if (this.props.state.actionLink.includes('?')) {
        window.open(`${this.props.state.actionLink}&actionKey=${res.data}`)
      } else {
        window.open(`${this.props.state.actionLink}?actionKey=${res.data}`)
      }

    }).catch(error => {
      console.log("Request failed", error);
    });
  }

  launchShortcut() {
    this.saveCaseUpdateAttributeData();
  }

  setRef(ref) {
    const { columns } = this.state;

    if (ref) {
      let _this = this;
      this.ref = ref;
      ref.current.columnManager.columns = columns;

      setTimeout(() => {
        ref.current.setLocale("all");
      }, 2000);

      ref.current.on("pageLoaded", () => {
        // This prevents duplicate handlers from being attached when navigate to new page
        // Without this, each page button click would trigger multiple data load requests
        $('.tabulator-pages button.tabulator-page').off('click');
        this.initiatePageNumberBtnEvent();
      });
      ref.current.on("rowClick", function (e, row) {
        ref.current.deselectRow();
        ref.current.selectRow(row);

        let caseData = row.getData();
        caseData.columns = _this.state.columns;
        _this.props.rowClick(caseData);
      });

      ref.current.on("dataLoaded", function(data){
        _this.displayLoader(false);
      });
    }
  }

  initiatePageActionBtnEvents = () => {
    let _this = this;
    $('.tabulator-paginator button.tabulator-page').on('click', (e) => {
      let clickedPage = $(e.target).attr('data-page'), nextDest;

      if (clickedPage == 'last') {
        nextDest = Number(_this.state.lastPage);
      } else if (clickedPage == 'first') {
        nextDest = 1;
      } else if (clickedPage == 'next') {
        nextDest = Number(_this.state.currentPage) + 1;
      } else if (clickedPage == 'prev') {
        nextDest = Number(_this.state.currentPage) - 1;
      }
      // Used unary plus operator to convert to number if it isn't already
      let start = ((nextDest - 1) * _this.state.paginationSize), end = +start + +_this.state.dataPerAPICall;
      _this.loadNonFirstPageData(start, end, nextDest);
    })
  }

  initiatePageNumberBtnEvent = () => {
    let _this = this;
    $('.tabulator-pages button.tabulator-page').on('click', (e) => {
      // Used unary plus operator to convert to number if it isn't already
      let nextDest = $(e.target).attr('data-page'), start = ((nextDest - 1) * _this.state.paginationSize), end = +start + +_this.state.dataPerAPICall;
      _this.loadNonFirstPageData(start, end, nextDest);
    });
  }

  loadFirstPageData = (resolve, sort) => {
    let _this = this;
    let workflowState = this.state.caseState !== "" ? this.state.caseState : this.state.caseStateId;
    let caseState = this.state.myCaseBtn ? 'MY_CASES' : this.state.caseState;
    this.displayLoader(true);

    // Ensure sort has locale - use current locale if not provided
    const locale = this.props.i18n?.language || "nb";
    const sortWithLocale = sort ? { ...sort, locale: sort.locale ?? locale } : sort;

    this.setState({sort: sortWithLocale})

    let resultedPromise;
    const filters = this.state.filters;

    if(filters.length > 0) {
      resultedPromise = this.state.searchText !== "" ? CaseAPI.searchCases(this.state.workflowId, this.state.exerciseId, caseState, this.state.searchText.toLowerCase(), workflowState, 0, this.state.dataPerAPICall, filters, sortWithLocale) :
          CaseAPI.allCasesWithFilters(this.state.workflowId, this.state.exerciseId, caseState, this.state.t, workflowState, 0, this.state.dataPerAPICall, filters, sortWithLocale);
    } else {
      resultedPromise = this.state.searchText !== "" ? CaseAPI.searchCases(this.state.workflowId, this.state.exerciseId, caseState, this.state.searchText.toLowerCase(), workflowState, 0, this.state.dataPerAPICall, [], sortWithLocale) :
          CaseAPI.all(this.state.workflowId, this.state.exerciseId, caseState, this.state.t, workflowState, 0, this.state.dataPerAPICall, sortWithLocale);
    }

    resultedPromise.then(allCaseData => {
      this.setState({ loadedData: allCaseData.data });
      _this.handleFirstPageData(allCaseData.data.content, allCaseData.data.totalElements, resolve);
      _this.displayLoader(false);
    }).catch(err => {
      console.log("Error Reading data " + err);
      _this.displayLoader(false);
    });
  }

  displayLoader = (visible) => {
    this.setState({ loading: visible });
  }

  handleFirstPageData = (data, totalElements, resolve) => {
    // Clean null values in received data
    data.forEach(item => this.removeNullValue(item, this.state.columns));

    const paddedData = [...data];
    for (let i = data.length; i < totalElements; i++) {
      paddedData.push({});
    }

    let pageInfo = {}, size = this.state.paginationSize, page = 0;
    for (let i = 0; i < paddedData.length; i += size) {
      let dataSlice = paddedData.slice(i, i + size);
      ++page;
      const firstRecord = dataSlice[0];
      const hasData = firstRecord && Object.keys(firstRecord).length !== 0;
      pageInfo[page] = hasData ? dataSlice.length : 0;
    }

    this.setState({
      presentData: paddedData,
      data: paddedData,
      lastPage: page,
      pageInfo: pageInfo,
      currentPage: 1
    });

    if (resolve) {
      resolve(paddedData);
      this.initiatePageActionBtnEvents();
      this.initiatePageNumberBtnEvent();
    } else {
      this.ref.current.setData(paddedData);
    }

    this.ref.current.columnManager.setColumns(this.state.columns);
    this.ref.current.columnManager.redraw(true);
  };

  loadNonFirstPageData = (start, end, nextDest) => {
    let _this = this;
    let workflowState = this.state.caseState !== "" ? this.state.caseState : this.state.caseStateId;
    let caseState = this.state.myCaseBtn ? 'MY_CASES' : this.state.caseState;
    if (this.state.pageInfo[nextDest] !== 0) {
      this.setState({ currentPage: nextDest });
      return;
    }
    this.displayLoader(true);

    let resultedPromise;
    const filters = this.state.filters;
    const sort = this.state.sort;

    if(filters.length > 0) {
      resultedPromise = this.state.searchText !== "" ? CaseAPI.searchCases(this.state.workflowId, this.state.exerciseId, caseState, this.state.searchText.toLowerCase(), workflowState, start, end, filters, sort) :
          CaseAPI.allCasesWithFilters(this.state.workflowId, this.state.exerciseId, caseState, this.state.t, workflowState, start, end, filters, sort);
    } else {
      resultedPromise = this.state.searchText !== "" ? CaseAPI.searchCases(this.state.workflowId, this.state.exerciseId, caseState, this.state.searchText.toLowerCase(), workflowState, start, end, [], sort) :
          CaseAPI.all(this.state.workflowId, this.state.exerciseId, caseState, this.state.t, workflowState, start, end, sort);
    }

    resultedPromise.then(allCaseData => {
      _this.handleNonFirstPageData(allCaseData.data.content, start, nextDest);
    }).catch(err => {
      console.log("Error Reading data " + err);
      _this.displayLoader(false);
    });
  }

  handleNonFirstPageData = (data, start, nextDest) => {
    // Normalize incoming records before merging them into the cached dataset
    data.forEach(item => this.removeNullValue(item, this.state.columns));

    const updatedData = [...this.state.data];
    let index = 0;
    for (let i = start; i < start + data.length; i++) {
      updatedData[i] = data[index++];
    }

    const updatedPageInfo = { ...this.state.pageInfo };
    const pageSize = this.state.paginationSize;
    let page = Number(nextDest);

    for (let i = 0; i < data.length; i += pageSize) {
      const dataSlice = data.slice(i, i + pageSize);
      const firstRecord = dataSlice[0];
      const hasData = firstRecord && Object.keys(firstRecord).length !== 0;
      updatedPageInfo[page] = hasData ? dataSlice.length : 0;
      page++;
    }

    this.setState({
      data: updatedData,
      pageInfo: updatedPageInfo,
      currentPage: Number(nextDest)
    }, () => {
      this.ref.current.replaceData(updatedData);
      this.initiatePageNumberBtnEvent();
      this.displayLoader(false);
    });
  };




  generateTitle = (type, key, title) => {
    const { t } = this.state;
    var translation = t(type + "." + key);
    if (translation.includes(type)) {
      return title;
    } else {
      return translation;
    }
  }


  checkboxListener = (val) => {
    const { wfColumns, columns, columnCount, data } = this.state;
    let tempColumns = columns;
    let selectedColumn = wfColumns.find(col => col.id === val);

    if (columns.some(col => col.field === selectedColumn.field)) {
      const filtered = columns.filter((col) => col.field !== selectedColumn.field);

      const filteredWfColumns = wfColumns.map(col => {
        if (col.id === val) {
          return { ...col, type: 'extra' };
        }
        return col;
      });

      this.decorateWithHighlight(filtered);

      this.setState({
        columns: filtered,
        wfColumns: filteredWfColumns,
        columnCount: columnCount - 1,
        tempSelectedColumns: filtered,
        tempWfColumns: filteredWfColumns
      });
      this.ref.current.columnManager.setColumns(filtered);
      this.ref.current.columnManager.redraw(true);
    } else {
      let record = {
        field: selectedColumn.field,
        width: selectedColumn.width,
        title: selectedColumn.title,
        align: selectedColumn.align,
        order: selectedColumn.order,
        sorter: selectedColumn.sorter || 'string',
      };

      // Add alignEmptyValues to new columns
      if (record.sorter === 'datetime' || record.sorter === 'date') {
        record = {
          ...record,
          sorterParams: {
            format: 'DD.MM.YYYY [kl.] HH:mm',
            alignEmptyValues: 'bottom',
          },
          formatter: 'datetime',
          formatterParams: {
            inputFormat: 'DD.MM.YYYY [kl.] HH:mm',
            outputFormat: 'DD.MM.YYYY [kl.] HH:mm',
            invalidPlaceholder: '',
          },
        };
      } else {
        record = {
          ...record,
          sorterParams: {
            alignEmptyValues: 'bottom',
          }
        };
      }

      const filteredWfColumns = wfColumns.map(col => {
        if (col.id === val) {
          return { ...col, type: 'default' };
        }
        return col;
      });

      tempColumns.push(record);
      tempColumns.sort((a, b) => a.order > b.order ? 1 : -1);
      // Apply highlighting formatter to updated columns
      this.decorateWithHighlight(tempColumns);

      data.forEach(item => this.removeNullValue(item, tempColumns));

      this.setState({
        data: data,
        columns: tempColumns,
        wfColumns: filteredWfColumns,
        columnCount: columnCount + 1,
        tempSelectedColumns: tempColumns,
        tempWfColumns: filteredWfColumns
      });
      this.ref.current.columnManager.setColumns(tempColumns);
      this.ref.current.columnManager.redraw(true)
    }
  };

  handleCaseButton = (button) => {
    const { data } = this.state;
    switch (button) {
      case 'allCaseBtn':
        this.setState({ allCaseBtn: true, myCaseBtn: false }, () => {
          this.loadFirstPageData();
        });
        break;
      case 'myCaseBtn':
        this.setState({ myCaseBtn: true, allCaseBtn: false }, () => {
          this.loadFirstPageData();
        });
        break;
      default:
        break;
    }
  }

  handleSearchBox = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
      isSearch: true
    }, () => {
      if (!this.state.isEnableSearchButton) {
        this.debouncedSearch(value);
      }
    });
  }

  getSearchCases = (searchText) => {
    this.loadFirstPageData();
  }

  handleSubmitSearch = (event) => {
    const { searchText } = this.state;
    this.getSearchCases(searchText);
  }

  handleClearButton = () => {
    // Cancel any pending debounced search to prevent unwanted API calls
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
    this.props.onResetPageData();
    this.setState({
      searchText: "",
      isSearch: false,
      pageData: this.props.state.data
    },()=>{
      this.loadFirstPageData();
    });
  }

  handleColumnsBtn = () => {
    this.setState({ columnsBtn: !this.state.columnsBtn })
  }

  exportTable = () => {
    let workflowState = this.state.caseState !== "" ? this.state.caseState : this.state.caseStateId;
    let caseState = this.state.myCaseBtn ? 'MY_CASES' : this.state.caseState,
      columnDefinitions = [];

    this.state.columns.forEach(c => {
      let parts = c.field.split(".");
      columnDefinitions.push({ "title": c.title, "dataElement": parts[0], "dataKey": parts[1] });
    });

    let workflowName = this.state.workflowList.find(wi => wi.workflow.workflowId == this.state.workflowId).workflow.name;

    CaseAPI.export(this.state.workflowId, this.state.exerciseId, caseState, this.state.searchText.toLowerCase(), workflowState,
        0, 10, columnDefinitions, this.state.caseStateTitle, workflowName, this.state.filters, this.state.sort).then(data => {
      $("#ActionAlert").appendTo("body").modal("show");
    })
  }

  render() {
    const {workflowIndex, isPinned, shortcutName, shortcutIcon} = this.props.state;
    const {
      columns,
      caseState,
      caseStateTitle,
      toggle,
      allCaseBtn,
      myCaseBtn,
      columnsBtn,
      t,
      pageData,
      wfColumns,
      isEnableSearchButton,
      caseStateId,
      loading
    } = this.state;

    const caseData = {
      allCaseBtn: allCaseBtn,
      myCaseBtn: myCaseBtn,
      workflowIndex: workflowIndex,
      caseStateId: caseStateId,
      t: t
    }

    return (
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <div className="box" state={caseState}>
                <div className="box-header">
                  <div className="shortcut-button">
                    {isPinned &&
                        <button type="button" className="btn btn-primary" onClick={e => {
                          e.preventDefault();
                          this.launchShortcut();
                        }}>
                          <i data-feather={shortcutIcon} />
                          {shortcutName}

                        </button>}
                  </div>
                  <p className="lead" style={{ marginBottom: 0 }}>
                    {this.generateTitle("caseManagement.viewDetails.stateType", caseStateTitle, caseStateTitle)}
                  </p>
                  {toggle && <div className="box-header">
                    <div className="row">
                      <div className="col-xs-5">
                        <Filter
                            caseData={caseData}
                            onHandleCaseBtn={this.handleCaseButton}
                            onHandleFilterData={(workflowIndex, caseStateId) =>
                                this.onHandleFilterData(workflowIndex, caseStateId)}
                        />

                      </div>
                      <div className="col-xs-5 right">
                        <div className="row">
                          <div className="col-xs-8">
                            <form className="form-inline ml-3" onSubmit={e => {
                              e.preventDefault();
                            }}>
                              <div className="input-group input-group-md">
                                <input type="text"
                                       className="form-control form-control-navbar"
                                       name="searchText"
                                       id="searchText"
                                       value={this.state.searchText}
                                       size={250}
                                       placeholder={t("userManagement.viewUsers.searchCases.placeholder")}
                                       onChange={this.handleSearchBox} />
                                {(this.state.searchText !== '') &&
                                    <button type="button" className="clear-button" onClick={(e) => this.handleClearButton()}><i data-feather='x' /></button>}
                              </div>

                            </form>
                          </div>
                          <div className="col-xs-4">
                            {
                                isEnableSearchButton && <button type="button"
                                                                onClick={this.handleSubmitSearch}
                                                                className="btn btn-primary btn-sm">
                                  search
                                  <i data-feather='search' />
                                </button>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-2 ">
                        <div className="dropdown">
                          <button className="dropbtn" onClick={this.handleColumnsBtn}>{t("portalSettings.caseStates.buttonLabel")} <i data-feather='columns' /></button>
                          {columnsBtn && <div className={"dropdown-content"}>
                            <p className="dropdown-title">{t("portalSettings.caseStates.dropdownTitle")}</p>
                            {wfColumns.length > 0 && wfColumns.map((column, idx) => (
                                <a key={idx} onClick={() => this.checkboxListener(column.id)} ><span style={{ marginLeft: 8, paddingRight: 8 }}><input className="medium" name="column" type="checkbox" checked={column.type === "default" ? true : false} value={column.id} />&nbsp;{column.title}</span></a>
                            ))}
                          </div>}
                        </div>
                      </div>
                    </div>
                  </div>}
                </div>
                <div className="box-body">

                  <ReactTabulator
                      onRef={ref => this.setRef(ref)}
                      columns={columns}
                      options={this.options}
                  />

                  <button id="export-table" type="button" disabled={this.state.data.length === 0} className="btn btn-primary" onClick={this.exportTable}>
                    {t("caseManagement.caseTable.exportButton.value")} <i data-feather='download' />
                  </button>
                </div>
              </div>
            </div>
            <div className="modal fade" id="ActionAlert">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>{t("caseManagement.caseTable.exportMessage")} </p>
                  </div>
                  <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-default col-md-2 pull-right"
                        data-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {loading && <Loading />}
          </div>
        </Fragment>
    );
  }
}

export default withTranslation("common")(CaseTable);